import React from "react";
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useCreateAccounts } from "queries/saas";
import { Link, useNavigate } from "react-router-dom";
import { useAgencyInfo } from "context/agency";
import Loader from "examples/Loader";
import Grid from "@mui/material/Grid";
import { Card, FormControlLabel, Slider, Switch, TextField, ToggleButton } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftModal from 'components/SoftModal'

import CreateModal from "./components/CreateModal/index";
import "./style.css"
import ConfigrationForm from "./components/configration/index"

const PotentialPricing = ({ data, handleRefresh }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false)
  // const [products, setproducts] = useState(data)
  const [prices, setPrices] = useState([])
  const queryClient = useQueryClient();
  const [agency] = useAgencyInfo();
  const [open, setOpen] = useState(false)
  const [openModal, setopenModal] = useState(false)
  const [editdata, seteditdata] = useState()
  const stripe_currency = [
    {
      "label": "usd",
      "value": "$"
    },
    {
      "label": "eur",
      "value": "€"
    },
    {
      "label": "jpy",
      "value": "¥"
    },
    {
      "label": "gbp",
      "value": "£"
    },
    {
      "label": "aud",
      "value": "A$"
    },
    {
      "label": "cad",
      "value": "C$"
    },
    {
      "label": "chf",
      "value": "Fr"
    },
    {
      "label": "cny",
      "value": "¥"
    },
    {
      "label": "sek",
      "value": "kr"
    },
    {
      "label": "nzd",
      "value": "NZ$"
    },
    {
      "label": "krw",
      "value": "₩"
    },
    {
      "label": "sgd",
      "value": "S$"
    },
    {
      "label": "nok",
      "value": "kr"
    },
    {
      "label": "mxn",
      "value": "Mex$"
    },
    {
      "label": "inr",
      "value": "₹"
    },
    {
      "label": "rub",
      "value": "₽"
    },
    {
      "label": "zar",
      "value": "R"
    },
    {
      "label": "try",
      "value": "₺"
    },
    {
      "label": "brl",
      "value": "R$"
    },
    {
      "label": "twd",
      "value": "NT$"
    },
    {
      "label": "dkk",
      "value": "kr"
    },
    {
      "label": "pln",
      "value": "zł"
    },
    {
      "label": "thb",
      "value": "฿"
    },
    {
      "label": "idr",
      "value": "Rp"
    },
    {
      "label": "huf",
      "value": "Ft"
    },
    {
      "label": "czk",
      "value": "Kč"
    },
    {
      "label": "ils",
      "value": "₪"
    },
    {
      "label": "clp",
      "value": "CLP$"
    },
    {
      "label": "php",
      "value": "₱"
    },
    {
      "label": "aed",
      "value": "د.إ"
    },
    {
      "label": "cop",
      "value": "COL$"
    },
    {
      "label": "sar",
      "value": "﷼"
    },
    {
      "label": "myr",
      "value": "RM"
    },
    {
      "label": "ron",
      "value": "lei"
    },
    {
      "label": "pkr",
      "value": "₨"
    },
    {
      "label": "vnd",
      "value": "₫"
    },
    {
      "label": "ngn",
      "value": "₦"
    },
    {
      "label": "egp",
      "value": "E£"
    },
    {
      "label": "bdt",
      "value": "৳"
    },
    {
      "label": "pyg",
      "value": "₲"
    },
    {
      "label": "irr",
      "value": "﷼"
    },
    {
      "label": "iqd",
      "value": "ع.د"
    },
    {
      "label": "dzd",
      "value": "DA"
    },
    {
      "label": "kwd",
      "value": "ك"
    },
    {
      "label": "uah",
      "value": "₴"
    },
    {
      "label": "hrk",
      "value": "kn"
    },
    {
      "label": "omr",
      "value": "﷼"
    },
    {
      "label": "tnd",
      "value": "د.ت"
    },
    {
      "label": "qar",
      "value": "﷼"
    },
    {
      "label": "crc",
      "value": "₡"
    },
    {
      "label": "ars",
      "value": "AR$"
    },
    {
      "label": "lkr",
      "value": "₨"
    },
    {
      "label": "vnd",
      "value": "₫"
    },
    {
      "label": "mad",
      "value": "د.م."
    },
    {
      "label": "npr",
      "value": "रू"
    },
    {
      "label": "uzs",
      "value": "сўм"
    },
    {
      "label": "mvr",
      "value": "ރ."
    },
    {
      "label": "jod",
      "value": "د.ا"
    },
    {
      "label": "bhd",
      "value": "ب.د"
    },
    {
      "label": "kzt",
      "value": "₸"
    },
    {
      "label": "byn",
      "value": "Br"
    },
    {
      "label": "lbp",
      "value": "ل.ل."
    },
    {
      "label": "gtq",
      "value": "Q"
    },
    {
      "label": "ttd",
      "value": "TT$"
    },
    {
      "label": "svc",
      "value": "₡"
    },
    {
      "label": "afn",
      "value": "؋"
    },
    {
      "label": "yer",
      "value": "﷼"
    },
    {
      "label": "bob",
      "value": "Bs"
    },
    {
      "label": "bmd",
      "value": "BD$"
    },
    {
      "label": "bzd",
      "value": "BZ$"
    },
    {
      "label": "xcd",
      "value": "EC$"
    },
    {
      "label": "gel",
      "value": "₾"
    },
    {
      "label": "jmd",
      "value": "J$"
    },
    {
      "label": "kyd",
      "value": "KY$"
    },
    {
      "label": "mnt",
      "value": "₮"
    },
    {
      "label": "nad",
      "value": "N$"
    },
    {
      "label": "pab",
      "value": "B/."
    },
    {
      "label": "sdg",
      "value": "ج.س."
    },
    {
      "label": "sdp",
      "value": "£S"
    },
    {
      "label": "lvl",
      "value": "Ls"
    },
    {
      "label": "ltl",
      "value": "Lt"
    },
    {
      "label": "zwd",
      "value": "Z$"
    },
    {
      "label": "awg",
      "value": "Afl."
    },
    {
      "label": "bbd",
      "value": "Bds$"
    },
    {
      "label": "bgn",
      "value": "лв"
    },
    {
      "label": "cdf",
      "value": "FC"
    },
    {
      "label": "xof",
      "value": "CFA"
    },
    {
      "label": "djf",
      "value": "Fdj"
    },
    {
      "label": "fkp",
      "value": "FK£"
    },
    {
      "label": "gip",
      "value": "GIP"
    },
    {
      "label": "gnf",
      "value": "FG"
    },
    {
      "label": "htg",
      "value": "HTG"
    },
    {
      "label": "iqd",
      "value": "ع.د"
    },
    {
      "label": "irr",
      "value": "﷼"
    },
    {
      "label": "isk",
      "value": "kr"
    },
    {
      "label": "lak",
      "value": "₭"
    },
    {
      "label": "lsl",
      "value": "LSL"
    },
    {
      "label": "mmk",
      "value": "K"
    },
    {
      "label": "mro",
      "value": "UM"
    },
    {
      "label": "mzn",
      "value": "MT"
    },
    {
      "label": "nio",
      "value": "C$"
    },
    {
      "label": "pgk",
      "value": "PGK"
    },
    {
      "label": "rwf",
      "value": "R₣"
    },
    {
      "label": "shp",
      "value": "£"
    },
    {
      "label": "std",
      "value": "Db"
    },
    {
      "label": "szl",
      "value": "E"
    },
    {
      "label": "top",
      "value": "T$"
    },
    {
      "label": "ugx",
      "value": "USh"
    },
    {
      "label": "vuv",
      "value": "VT"
    },
    {
      "label": "wst",
      "value": "WS$"
    },
    {
      "label": "xaf",
      "value": "FCFA"
    },
    {
      "label": "xpf",
      "value": "F"
    },
    {
      "label": "zmw",
      "value": "ZK"
    }
  ]

  const openModal_getId = (item) => {
    seteditdata(item)
    setopenModal(true);
  }
  const { mutateAsync: createAccounts } = useCreateAccounts();
  const handleCreateAccounts = async (product_id) => {
    const payload = {
      product_id: product_id
    }
    const { response } = await createAccounts(payload);
  }
  return (<>
    <Grid container spacing={12}>
      <Grid item xs={12}>
        <Card style={{ paddingTop: "20px" }}>

          <SoftBox pt={3} px={3}>

            {data?.products?.length > 0 && data.products?.map((item, index) => (
              <div className="box_border" key={index} >
                <div className="">
                  <div className="mainboxwithdevidegrid">
                    <div style={{ width: "60%" }}>

                      <h5 className="py-z-5">
                        {item.name} <span className="getfirstchracteronly">
                          {item.type}</span></h5>
                      {item.id}
                      <div className="py-z-5">
                        <h5>FEATURES</h5>
                        <div className="flex-flex-wrap" style={{ width: "50%" }}>
                          {item?.configurations?.apps?.includes("AI Social App") &&
                            <div className="everyicon-z">
                              <div className="ml-2 mr-2 mb-2 ">

                                <div className="border-gray-300 border rounded-full h-9 w-9 p-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="h-4 w-4 border-gray-600">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M10 15l-3.075 3.114c-.43.434-.644.651-.828.666a.5.5 0 01-.421-.172c-.12-.14-.12-.446-.12-1.056v-1.56c0-.548-.449-.944-.99-1.024v0a3 3 0 01-2.534-2.533C2 12.219 2 11.96 2 11.445V6.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C4.28 2 5.12 2 6.8 2h7.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C19 4.28 19 5.12 19 6.8V11m0 11l-2.176-1.513c-.306-.213-.46-.32-.626-.395a2.002 2.002 0 00-.462-.145c-.18-.033-.367-.033-.74-.033H13.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C10 18.394 10 17.834 10 16.714V14.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C11.52 11 12.08 11 13.2 11h5.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C22 12.52 22 13.08 22 14.2v2.714c0 .932 0 1.398-.152 1.766a2 2 0 01-1.083 1.082c-.367.152-.833.152-1.765.152V22z"></path>
                                  </svg>
                                </div>
                              </div>
                            </div>}

                          {item?.configurations?.apps.includes("AI Celender App") && <div className="everyicon-z">
                            <div className="ml-2 mr-2 mb-2 ">

                              <div className="border-gray-300 border rounded-full h-9 w-9 p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="h-4 w-4 border-gray-600">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M21 10H3m13-8v4M8 2v4m2.5 8l1.5-1v5m-1.25 0h2.5M7.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C5.28 22 6.12 22 7.8 22z"></path>
                                </svg>
                              </div>

                            </div>
                          </div>}

                        </div>
                      </div>

                    </div>
                    <div style={{ width: "40%" }}>
                      <div style={{
                        display: 'flex',
                        justifyContent: "flex-end",
                        marginBottom: "10px"
                      }}>

                        <h5>No of Locations:{data?.locations?.filter((location) => location?.product_id == item.id)?.length}</h5>
                      </div>
                      <div className="flex-flex-wrap justify-between">

                        {data?.prices.length > 0 && data.prices.filter(price => price.productId === item.id)?.map((itemprices, index) => (
                          <div className="box_border w-45 mx-1 p-2" key={index}>
                            <div className="flex-flex-wrap justify-between ">
                              <h3>{itemprices.interval}</h3>
                              <svg width={"40"} data-v-fc6bd6f8="" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="h-5 w-5 border-gray-700 text-gray-700 ml-1"><path stroke-linecap="round" stroke-linejoin="round" d="M9 17H7A5 5 0 017 7h2m6 10h2a5 5 0 000-10h-2m-8 5h10"></path></svg>
                            </div>
                            <h1>{stripe_currency?.filter((item) => item.label == itemprices?.currency)[0]?.value} {itemprices.unit_amount ? itemprices.unit_amount / 100 : 0}</h1>
                            {/* <hr></hr> */}
                            <div className="text-center font-15 ">
                            </div>
                          </div>
                        ))}




                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="hl-card-footer" style={{ width: "100%" }}>
                      <div className="d-flex justify-between p-2">
                        <div className="d-flex pt-2 font-semibold">
                          {/* <div className="d-flex p-2">
                            <svg width={"20"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="mr-2 w-4 text-gray-400">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9.5v4l2.5 1.5M12 5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm0 0V2m-2 0h4m6.329 3.592l-1.5-1.5.75.75m-15.908.75l1.5-1.5-.75.75"></path>
                            </svg>
                            <div className="font-15 onlinetext">{item?.configurations?.trial_and_credit.days} Days Trial Period</div>
                          </div> */}
                          <div className="d-flex p-2">
                            <svg width={"20"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="mr-2 w-4 text-gray-400">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M13.53 8.352a3.5 3.5 0 11.941-4.704M6 20.088h2.61c.34 0 .679.04 1.009.12l2.758.67c.598.147 1.222.16 1.826.043l3.05-.593a4.204 4.204 0 002.127-1.107l2.158-2.1a1.503 1.503 0 000-2.168 1.61 1.61 0 00-2.06-.143l-2.515 1.835c-.36.263-.799.405-1.25.405h-2.427 1.545c.871 0 1.577-.687 1.577-1.534v-.307c0-.704-.492-1.317-1.194-1.487l-2.385-.58A5.03 5.03 0 0011.643 13c-.965 0-2.711.799-2.711.799L6 15.025M20 6.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM2 14.6v5.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 00.437-.437C6 21.24 6 20.96 6 20.4v-5.8c0-.56 0-.84-.109-1.054a1 1 0 00-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C2 13.76 2 14.04 2 14.6z"></path>
                            </svg>
                            <div className="font-15 onlinetext">${item?.configurations?.trial_and_credit.credit_amount}    Complimentary Credits</div>
                          </div>
                        </div>
                        <div className="d-flex">
                          {item?.configurations &&
                            <SoftButton
                              onClick={() => navigate(`./${item.id}/accounts`)}
                              sx={{
                                marginLeft: 'auto',
                              }}
                              variant="info"
                            >
                              <span className="flex-flex-wrap">
                                <svg width={"20"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="mr-2 h-5 w-5 text-gray-800">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M21.152 10.9l-9.015 9.015a5.25 5.25 0 01-7.425-7.425l9.016-9.015a3.5 3.5 0 114.95 4.95l-8.662 8.662a1.75 1.75 0 11-2.475-2.475l7.601-7.602"></path>
                                </svg>
                                <div className="font-15">Create Account Manually</div>
                              </span>
                            </SoftButton>
                          }
                          {item?.configurations && <SoftButton
                            onClick={() => handleCreateAccounts(item.id)}
                            sx={{
                              marginLeft: 'auto',
                            }}
                            variant="info"
                          >
                            <span className="flex-flex-wrap">
                              <svg width={"20"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="mr-2 h-5 w-5 text-gray-800">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M21.152 10.9l-9.015 9.015a5.25 5.25 0 01-7.425-7.425l9.016-9.015a3.5 3.5 0 114.95 4.95l-8.662 8.662a1.75 1.75 0 11-2.475-2.475l7.601-7.602"></path>
                              </svg>
                              <div className="font-15">Create Account Automatically</div>
                            </span>
                          </SoftButton>}

                          <SoftButton
                            sx={{
                              marginLeft: 'auto',
                            }}
                            variant="info"
                            onClick={() => { openModal_getId(item) }}
                          >
                            <span className="flex-flex-wrap">
                              <svg width={"20"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="mr-2 h-5 w-5 text-gray-700">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M18 10l-4-4M2.5 21.5l3.384-.376c.414-.046.62-.069.814-.131a2 2 0 00.485-.234c.17-.111.317-.259.61-.553L21 7a2.828 2.828 0 10-4-4L3.794 16.206c-.294.294-.442.442-.553.611a2 2 0 00-.234.485c-.062.193-.085.4-.131.814L2.5 21.5z"></path>
                              </svg>
                              <div className="font-15">CONFIGURATION</div>
                            </span>
                          </SoftButton>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            ))}
            {data?.products?.length < 1 && <p style={{ textAlign: "center" }}>
              please make sure your account  integrated succesfully
            </p>}
          </SoftBox>
        </Card>
      </Grid>
      {openModal &&
        <SoftModal
          open={openModal}
          onClose={() => setopenModal(false)}
          height={600}
          width={"80%"}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ConfigrationForm editdata={editdata} onClose={() => setopenModal(false)} handleRefresh={handleRefresh} />

        </SoftModal>}


    </Grid>
  </>)
}
export default PotentialPricing